import version2 from "./index_v2";

export default version2;
